import { render, staticRenderFns } from "./TopMaisVendidosCard.vue?vue&type=template&id=d22e09c4"
import script from "./TopMaisVendidosCard.vue?vue&type=script&lang=js"
export * from "./TopMaisVendidosCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports